/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentQueryOwner extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmDocumentQueryOwner");
    }

    getFixupPrototypeFunction() { return AwsSsmDocumentQueryOwner.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentQueryOwner>): AwsSsmDocumentQueryOwner {
        let obj = Object.assign(new AwsSsmDocumentQueryOwner(), model);
        AwsSsmDocumentQueryOwner.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentQueryOwner>): AwsSsmDocumentQueryOwner {
        if (!model) return null;
        return AwsSsmDocumentQueryOwner.newInstance(<AwsSsmDocumentQueryOwner> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentQueryOwner) {
        if (!obj) return;

        models.AwsSsmDocumentQueryOwner.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentQueryOwner): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmDocumentQueryOwner.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Owners for the findings
     */
    owners: Array<string>;

}
